export default __webpack_public_path__ + "static/media/more_horiz.a342fd78.svg";